import { render, staticRenderFns } from "./RsaRiepilogoAccessiAdiListComponent.vue?vue&type=template&id=2d423151"
import script from "./RsaRiepilogoAccessiAdiListComponent.vue?vue&type=script&lang=js"
export * from "./RsaRiepilogoAccessiAdiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports